// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"b0ec3078","355":"03dc895f","457":"2d220d9a","525":"bef6b58e","801":"fb193c33"}[chunkId] + ".chunk.css";
};